export enum TypeOrder {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM',
  SUPER = 'SUPER',
  STANDARD_PLUS = 'STANDARD_PLUS',
  KOREA = 'KOREA',
  CARGO = 'CARGO',
}
